import { useScrollReveal } from "@/hooks/useScrollReveal";
import HeroSection from "./components/HeroSection";
import StickyNavSection from "./components/StickyNavSection";
import AboutSection from "./components/AboutSection";
import CaseListSection from "./components/CaseListSection";
import CaseDetailSection from "./components/CaseDetailSection";
import OurApproachSection from "./components/OurApproachSection";
import RelatedServicesSection from "./components/RelatedServicesSection";
import CTASection from "./components/CTASection";
import { caseStudiesData } from "@/mocks/caseStudiesData";

export default function CaseStudiesPage() {
  useScrollReveal();

  return (
    <>
      <HeroSection />
      <StickyNavSection />
      <AboutSection />
      <CaseListSection />
      <div className="bg-background-50">
        <CaseDetailSection caseData={caseStudiesData.case01} sectionId="case-01" />
      </div>
      <div className="bg-background-100">
        <CaseDetailSection caseData={caseStudiesData.case02} sectionId="case-02" />
      </div>
      <div className="bg-background-50">
        <CaseDetailSection caseData={caseStudiesData.case03} sectionId="case-03" />
      </div>
      <OurApproachSection />
      <RelatedServicesSection />
      <CTASection />
    </>
  );
}